import CommissionCalculator from './CommissionCalculator';

export default CommissionCalculator;
